// extracted by mini-css-extract-plugin
export default {"container":"display-date_container__wbjyn","year":"display-date_year__HOMLy"};